import * as services from "../services/api";
import {
  extendedSpaceToRepresentation,
  ownerToRepresentation,
  interestToRepresentation,
  postToRepresentation,
} from "./models";
import {
  POST_REQUEST,
  SPACE_REQUEST,
  BANNER_REQUEST,
  POST_REQUEST_FAILURE,
  SPACE_REQUEST_FAILURE,
  BANNER_REQUEST_FAILURE,
  POST_REQUEST_SUCCESS,
  SPACE_REQUEST_SUCCESS,
  BANNER_REQUEST_SUCCESS
} from "./types";

export default {
  namespaced: true,
  state: {
    attachments_hashs : null,
    video_to_resume_now: null,
    video_paused_from_popup: null,
    post: {
      data: null,
      fetching: false,
      errorCode: null,
    },
    space: {
      data: null,
      fetching: false,
      errorCode: null,
    },
    banner: {
      data: null,
      fetching: false,
      errorCode: null,
    }
  },
  mutations: {

    setAttachementsHashes(state, attachmentsHashsObject){
      state.attachments_hashs = attachmentsHashsObject; 
    },
    setVideToResumeNow(state, videoIndex){
      state.video_to_resume_now = videoIndex; 
    },
    clear_VideToResumeNow(state){
      state.video_to_resume_now = null; 
    },
    setVideoPauseFromPopUp(state, videoIndex){
      state.video_paused_from_popup = videoIndex; 
    },
    clear_VideoPauseFromPopUp(state){
      state.video_paused_from_popup = null; 
    },
    [POST_REQUEST](state) {
      state.post.fetching = true;
    },
    [SPACE_REQUEST](state) {
      state.space.fetching = true;
    },
    [BANNER_REQUEST](state) {
      state.banner.fetching = true;
    },
    [SPACE_REQUEST_SUCCESS](state, payload) {
      state.space.data = payload;
      state.space.fetching = false;
    },
    [POST_REQUEST_SUCCESS](state, payload) {
      state.post.data = payload;
      state.post.fetching = false;
    },
    [BANNER_REQUEST_SUCCESS](state, payload){
      state.banner.data = payload;
      state.banner.fetching = false;
    },
    [SPACE_REQUEST_FAILURE](state, error) {
      state.space.errorCode = error;
      state.space.fetching = false;
    },
    [POST_REQUEST_FAILURE](state, error) {
      state.post.errorCode = error;
      state.post.fetching = false;
    },
    [BANNER_REQUEST_FAILURE](state, error) {
      state.banner.errorCode = error;
      state.banner.fetching = false;
    }

  },
  getters: {
    getAttachmentsHashs(state){
      return state.attachments_hashs;
    },
    get_video_paused_from_popup(state){
      return state.video_paused_from_popup;
    },
    post(state) {
      let post = state.post.data;
      return post ? postToRepresentation(post) : null;
    },
    space(state) {
      let space = state.space.data;
      return space
        ? {
            ...extendedSpaceToRepresentation(space.space),
            interest: interestToRepresentation(space.interest),
            owner: ownerToRepresentation(space.owner),
          }
        : null;
    },
    banner(state){
      let bannerData = state.banner.data;
      let bannerExc = state.banner.errorCode;
      if (bannerData && !bannerExc){
        return bannerData
      }else {
        return bannerExc;
      }
    }
  },
  actions: {
    async setAttachementsHashes_Action({ commit }, attachementsHashes) {
      commit('setAttachementsHashes', attachementsHashes);
    },
    async clear_VideToResumeNow_Action({ commit }) {
      commit('clear_VideToResumeNow');
    },
    async clear_VideoPauseFromPopUp_Action({ commit }) {
      commit('clear_VideoPauseFromPopUp');
    },
    async setVideToResumeNow_Action({ commit }, videoID) {
      commit('setVideToResumeNow', videoID);
    },
    async setVideoPauseFromPopUp_Action({ commit }, videoID) {
      commit('setVideoPauseFromPopUp', videoID);
    },
    async getPost({ commit }, postID) {
      commit(POST_REQUEST);
      services
        .getPost(postID)
        .then((data) => {
          commit(POST_REQUEST_SUCCESS, data);
        })
        .catch((error) => commit(POST_REQUEST_FAILURE, error.response.status));
    },
    async getSpace({ dispatch, commit }, zipCode) {
      commit(SPACE_REQUEST);
      try {
        let data = await services.getSpace(zipCode);
        commit(SPACE_REQUEST_SUCCESS, data);
        dispatch("getSpacePost", data.space.id);
      } catch (error) {
        commit(SPACE_REQUEST_FAILURE, error.response.status);
      }
    },
    async getSpacePost({ commit }, spaceID) {
      commit(POST_REQUEST);
      services
        .getSpacePost(spaceID)
        .then((data) => {
          commit(POST_REQUEST_SUCCESS, data);
        })
        .catch((error) => commit(POST_REQUEST_FAILURE, error.response.status));
    },
    async getBanners({ commit }, payload) {
      commit(BANNER_REQUEST);
      const CLOUDFRONT_URL = process.env.VUE_APP_CLOUDFRONT_URL;
      let url = CLOUDFRONT_URL + payload.url
      
      services
        .getBanners(url)
        .then((data) => {
          commit(BANNER_REQUEST_SUCCESS, data);
        })
        .catch((error) => commit(BANNER_REQUEST_FAILURE, error.response.status));
    },

  },
};


